import PropTypes from 'prop-types'

import Layout from '@/components/Layout'

export default function Error({ title }) {
  return (
    <Layout.Card className="text-align_center" intent="danger">
      <Layout.Header>{title}</Layout.Header>
    </Layout.Card>
  )
}

Error.propTypes = {
  title: PropTypes.node.isRequired,
}
